export enum ChallengeTutorialType {
    CREATE_CHALLENGE,
  }